import React from "react";
import { useLocation } from "react-router-dom";

const QuizFeedback = () => {
  const location = useLocation();
  console.log(location.state);
  const questions = location.state.generatedQuestions;
  const userAnswers = location.state.userAnswers;
  const correctAnswers = location.state.correctAnswers;
  const correctAnswerStyle = { color: "green" };
  const incorrectAnswerStyle = { color: "red" };

  return (
    <div className="container" style={{ minHeight: "80vh" }}>
      <div className="text-center mt-3 mb-5">
        <h4>Quiz Feedback</h4>
      </div>
      <div className="text-center mt-3 mb-3">
        <h5>
          You answered {correctAnswers} / {questions.length} questions
          correctly!
        </h5>
      </div>
      <ul style={{ marginBottom: "40px" }}>
        {questions.map((question, index) => (
          <li key={index}>
            <h6>{question.question}</h6>
            <ul>
              {question.choices.map((choice, choiceIndex) => (
                <li key={choiceIndex}>
                  <span
                    style={
                      choice.isCorrect
                        ? correctAnswerStyle
                        : userAnswers[index] === choiceIndex
                        ? incorrectAnswerStyle
                        : {}
                    }
                  >
                    {choice.text}
                    {choice.isCorrect && (
                      <span className="answer-indicator">(Correct)</span>
                    )}
                    {userAnswers[index] === choiceIndex &&
                      !choice.isCorrect && (
                        <span className="answer-indicator">(Your Answer)</span>
                      )}
                  </span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuizFeedback;
